const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';

const changeLocale = (languageLocale) => ({
  type: CHANGE_LOCALE,
  locale: languageLocale,
});

export { CHANGE_LOCALE, changeLocale };
